import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_RESULTS = "results";
const BASE_URL = "/api/results";

const ResultQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const RESULT_EMPTY =
    {
        title: "",
        description: "",
        date: "",
        resultFile: []
    };

export function useResults() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_RESULTS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...ResultQueryConfig
    });
    return {...result, results: result.data};
}


export function useResult(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_RESULTS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...ResultQueryConfig
    });
    return {...result, result: result.data};
}

export function useResultMutations() {
    async function createFunction(result) {
        if (!result) return;
        return await fetchPOST(BASE_URL, result, false);
    }

    async function editFunction(result) {
        if (!result) return;
        return await fetchPUT(`${BASE_URL}/${result.id}`, result);
    }

    async function editAddNewResultFiles(result) {
        if (!result) return;
        return await fetchPUT(`${BASE_URL}/${result.id}/files`, result.fileId);
    }

    async function editAddAlbums(result) {
        if (!result) return;
        return await fetchPUT(`${BASE_URL}/${result.id}/resultfiles`, result.resultFile);
    }

    async function deleteFunction(result) {
        return await fetchDELETE(`${BASE_URL}/${result.id}`)
    }

    return {
        createResult: useMyMutation(createFunction, REACT_QUERY_ID_RESULTS, result => `Result ${result.title} created`),
        editResult: useMyMutation(editFunction, REACT_QUERY_ID_RESULTS, result => `Result ${result.title} modified`),
        editAddNewResultFiles: useMyMutation(editAddNewResultFiles, REACT_QUERY_ID_RESULTS, result => `Result ${result.title} modified`),
        editAddAlbums: useMyMutation(editAddAlbums, REACT_QUERY_ID_RESULTS, result => `Result ${result.title} modified`),
        deleteResult: useMyMutation(deleteFunction, REACT_QUERY_ID_RESULTS, result => `Result ${result.title} deleted.`)
    };

}